import { render, staticRenderFns } from "./LineageDs.vue?vue&type=template&id=6a176c84&scoped=true&lang=pug"
import script from "./LineageDs.vue?vue&type=script&lang=js"
export * from "./LineageDs.vue?vue&type=script&lang=js"
import style0 from "./LineageDs.vue?vue&type=style&index=0&id=6a176c84&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a176c84",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/jquispe/itcm-inca-platform-app/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6a176c84')) {
      api.createRecord('6a176c84', component.options)
    } else {
      api.reload('6a176c84', component.options)
    }
    module.hot.accept("./LineageDs.vue?vue&type=template&id=6a176c84&scoped=true&lang=pug", function () {
      api.rerender('6a176c84', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/tasks/datastudio/components/LineageDs.vue"
export default component.exports